<template>
  <div class="tag-details">
    <div class="type-content content">
      <div class="selected-activity caption bold">标签信息</div>
      <div class="flex">
        <div class="item">
          <span class="label">状态：</span>
          <span class="success" v-if="details.auditState === 'yes'"
            >运行中</span
          >
          <span class="gray" v-else-if="details.auditState === 'auditing'"
            >待审批</span
          >
          <span class="gray" v-else>不通过</span>
        </div>
        <div class="item">分类：{{ details.catDisplayName }}</div>
        <div class="item">标签名称：{{ details.tagName }}</div>
        <div class="item">
          数据类型：{{ details.createType === "multiAttr" ? "string" : "" }}
        </div>
        <div class="item">
          更新方式：{{ details.tagUpdateTimeTypeFormat }}
          {{ details.tagUpdateStartTime }}至{{ details.tagUpdateEndTime }}
        </div>
      </div>
      <div class="tag-describe">
        <div>{{ details.tagRemark }}</div>
        <div class="tag-remark flex item-center" :title="tagListStr">
          <div class="flex-1 text-overflow">
            <template v-if="details.createType === 'multiAttr'">
              通过手动创建，共有{{ tagList.length }}个属性，分别为
              <template v-for="(v, i) in tagList">
                <span class="mr10" :key="i">{{ v.tagName }} </span>
              </template>
            </template>
            <template v-if="details.createType === 'sql'">
              通过SQL创建</template
            >
          </div>
          <div class="link pointer" @click="viewRules">
            查看规则
            <span class="hmicon icon-youjiantou"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="range-content content">
      <div class="selected-activity caption bold">
        标签<template v-if="details.tagType === 'user'">人数</template
        ><template v-if="details.tagType === 'goods'">商品</template>分布
      </div>
      <div class="statistics flex item-center pointer" @click="showDetails">
        <span class="count bold"
          >{{ totalCount
          }}<template v-if="details.tagType === 'user'">人</template
          ><template v-if="details.tagType === 'goods'">件商品</template></span
        >
        <!-- <span>基准时间：{{ baseDate }}</span> -->
        <span>计算完成于：{{ calcEndTime }}</span>
      </div>
      <div class="range-chart">
        <div class="tag-type-list">
          <div
            class="tag-type-item pointer"
            :style="{ width: v.percentage, backgroundColor: v.bgColor }"
            v-for="(v, i) in rangeList"
            @click="viewCurrentDetails(v)"
            :key="i"
          >
            <div class="attr">{{ v.name }}</div>
            <div class="count" :class="{ 'in-top': v.percent > 85 }">
              <span class="mr10"
                >{{ v.count
                }}<template v-if="details.tagType === 'user'">人</template
                ><template v-if="details.tagType === 'goods'"
                  >件</template
                ></span
              >
              <span>{{ v.percentage }}</span>
            </div>
          </div>
        </div>
        <div
          class="x-axias flex"
          :style="{ height: rangeList.length * 58 + 14 + 'px' }"
        >
          <span class="scale flex-1" v-for="(v, i) in scaleList" :key="i">
            {{ v }}%
          </span>
        </div>
      </div>
    </div>
    <div class="history-content content">
      <div class="selected-activity caption bold">标签历史详情</div>
      <div class="flex item-center flex-end">
        <span>时间：</span>
        <el-date-picker
          v-model="dateRangeList"
          size="small"
          type="daterange"
          :clearable="false"
          @change="queryDetails"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </div>
      <ve-histogram
        v-if="chartData.columns.length"
        :data="chartData"
        :settings="chartSettings"
      ></ve-histogram>
      <el-table stripe :data="tableData">
        <el-table-column
          header-align="center"
          align="center"
          :label="v.prop"
          v-for="(v, i) in columns"
          :key="i"
        >
          <template v-slot="scope">
            <span> {{ scope.row[columns[i].prop + "value"] }}</span>
            <span
              v-if="scope.row[columns[i].prop + 'percent']"
              class="percentage"
            >
              ({{ scope.row[columns[i].prop + "percent"] }})</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="log-content content">
      <div class="selected-activity caption bold">标签日志&备注</div>
      <el-table stripe size="small" :data="logList">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operaterContent"
          label="日志内容"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="日志时间"
        ></el-table-column>
      </el-table>
    </div>
    <create-tag
      v-if="drawerVisible"
      :drawerVisible="drawerVisible"
      :tagDetails="tagDetails"
      :queryTagDetailsId='queryTagDetailsId'
      disabled
      @closeDrawer="closeDrawer"
    ></create-tag>
    <el-dialog title="提示" :visible.sync="detailDialogVisible">
      <div class="flex item-center" style="justify-content: space-between;">
        <el-button size="small" type="primary" @click="batchDelete"
          >批量删除</el-button
        >
        <div class="table-panel flex flex-end">
          <el-input
            class="mr10"
            size="small"
            v-model="queryName"
            :placeholder="
              details.tagType === 'user' ? '请输入姓名' : '请输入商品名'
            "
          ></el-input>
          <el-button size="small" type="primary" @click="paging(1)"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="table"
          :data="detailsList"
          size="small"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            v-if="details.tagType === 'user'"
            prop="mobile"
            label="会员手机号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            v-if="details.tagType === 'user'"
            prop="memberName"
            label="客户姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            v-if="details.tagType === 'goods'"
            prop="spuName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            v-if="details.tagType === 'goods'"
            prop="selectId"
            label="商品分类"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="calcValue"
            label="标签值"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="calcValue"
            label="标签值"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="toDetails(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import createTag from "@/views/portraitLabelMgt/modules/createTag";
import veHistogram from "v-charts/lib/histogram.common";
import moment from "moment";
export default {
  components: {
    veHistogram,
    createTag
  },
  data() {
    return {
      queryTagDetailsId: '',
      currentPage: 1,
      tagListStr: "",
      pageSize: 10,
      total: 0,
      queryName: "",
      id: "",
      detailsList: [],
      list: [],
      allKeyList: [],
      tagDetails: {},
      detailDialogVisible: false,
      drawerVisible: false,
      chartSettings: {},
      legend: { show: false },
      totalCount: 0,
      baseDate: "",
      calcEndTime: "",
      logList: [],
      details: {},
      regateList: [],
      chartData: {
        columns: [],
        rows: []
      },
      scaleList: [],
      rangeList: [],
      date: [],
      tableData: [],
      tableHeader: [],
      tableBody: [],
      columns: [],
      updateCycleList: [
        {
          name: "每天更新",
          value: "day"
        },
        {
          name: "每周更新",
          value: "week"
        },
        {
          name: "每月更新",
          value: "month"
        },
        {
          name: "每年更新",
          value: "year"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      dateRangeList: [],
      tagList: []
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.dateRangeList = [
      moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    this.queryDetails();
  },
  mounted() {},
  methods: {
    showDetails() {
      console.log(88);
      this.detailDialogVisible = true;
      this.queryTagIncludeResultList();
    },
    async toDetails(row) {
      const result = await this.$confirm("是否删除该信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("queryTagDelete", {
          ids: row.id,
          source: "detail",
          state: "0"
        });
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.queryTagIncludeResultList();
      }
    },
    async batchDelete() {
      if (this.regateList.length > 1) {
        await this.$confirm("是否删除选中信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let allId = this.regateList.join(",");
          this.$store
            .dispatch("queryTagDelete", {
              ids: allId,
              source: "detail",
              state: "0"
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.queryTagIncludeResultList();
              }
            });
        });
      } else {
        this.$message.error("请选择1条以上的信息");
      }
    },
    viewCurrentDetails(row) {
      this.detailDialogVisible = true;
      this.queryTagIncludeResultList(row.name);
    },
    paging(page) {
      this.currentPage = page;
      this.queryTagIncludeResultList();
    },
    handleSelectionChange(val) {
      let ids = val.map(items => items.id);
      this.regateList = ids;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.queryTagIncludeResultList();
    },
    async queryTagIncludeResultList(calcValue) {
      const { result } = await this.$store.dispatch(
        "queryTagIncludeResultList",
        {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          tagId: this.details.tagKey,
          tagType: this.details.tagType,
          queryName: this.queryName,
          storeCode: this.details.tenantId,
          calcValue
        }
      );
      const { records, total } = result;
      this.detailsList = records;
      this.total = total;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryTagRunDetails", {
        id: this.id,
        beginDate: this.dateRangeList[0],
        endDate: this.dateRangeList[1]
      });
      this.details = result;
      this.calcEndTime = result.calcEndTime
        ? moment(result.calcEndTime).format("YYYY-MM-DD HH:mm:SS")
        : "暂未开始计算";
      this.details.tagUpdateTimeTypeFormat = this.updateCycleList.find(
        v => v.value === result.tagUpdateTimeType
      ).name;
      if (result.createType !== "sql") {
        const list = JSON.parse(result.tagRunInfo);
        this.tagList = list;
        let keyList = [];
        keyList = this.tagList.map(v => v.tagName);
        console.log("keyList: ", keyList);
        this.tagListStr = keyList.join(",");
        const { divInfo, data } = result.dataReport;
        if (!divInfo.length) {
          return;
        }
        this.totalCount = result.dataReport.totalCount;
        this.setRange(divInfo, keyList);
        this.createChart(data, keyList);
        this.createTable(data, keyList);
      }
      this.logList = this.details.operatorHis;
    },
    setRange(divInfo, keyList) {
      // 初始化x轴
      for (let i = 0; i <= 10; i++) {
        this.scaleList.push(i * 10);
      }
      let colorList = [
        "#1BE9BF",
        "#63C2FF",
        "#FF7993",
        "#FFCB8C",
        "#0071B6",
        "#D7C6FA",
        "#ED868C",
        "#ABCDFF",
        "#EEE4DA",
        "#94B9A6",
        "#E9ADB2",
        "#64504E",
        "#87B3B8"
      ];
      let newColorList = [];
      let len = divInfo.length;
      if (len > colorList.length) {
        let loopTimes = 0;
        loopTimes = Math.floor(len / colorList.length);
        for (let i = 0; i < loopTimes; i++) {
          newColorList.push(...colorList);
        }
        const othersLen = len - loopTimes * colorList.length;
        newColorList.push(...colorList.slice(0, othersLen));
      } else {
        newColorList = colorList;
      }
      divInfo.forEach((v, i) => {
        newColorList.map((o, oi) => {
          if (i === oi) {
            v.bgColor = o;
          }
        });
        Object.keys(v).forEach(o => {
          keyList.map(key => {
            if (key === o) {
              v.name = key;
              v.count = v[key];
              v.isLessThan7percent = v.percentage.split("%")[0] < 7; // 防止文字换行显示异常
              v.percent = v.percentage.split("%")[0];
            }
          });
        });
      });
      this.rangeList = divInfo;
    },
    createTable(data, keyList) {
      const copyData = JSON.parse(JSON.stringify(data));
      console.log("data: ", data);

      let tableData = [
        {
          key: "全部"
        }
      ];
      keyList.map(key => {
        tableData.push({
          key
        });
      });
      console.log("this.details: ", this.details);
      this.columns = [
        {
          prop: this.details.tagName
        }
      ];
      copyData.map(v => {
        this.columns.push({
          prop: v.date
        });
        Object.keys(v).map(key => {
          tableData.map(o => {
            if (key === o.key) {
              o[this.details.tagName + "value"] = key;
              o[v.date + "value"] = v[key];
              o[v.date + "percent"] = v[key + "_percentage"];
            }
          });
        });
      });
      this.tableData = tableData;
      console.log("tableData: ", tableData);
    },
    createChart(data, keyList) {
      const copyData = JSON.parse(JSON.stringify(data));
      copyData.forEach(v => {
        v["日期"] = v.date;
      });
      this.chartData = {
        columns: ["日期", ...keyList],
        rows: copyData
      };
    },
    async viewRules() {
      console.log('this.id',this.id)
      this.queryTagDetailsId = this.id
      const { result } = await this.$store.dispatch("queryTagDetails", {
        id: this.id
      });
      this.tagDetails = result;
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.tag-details {
  font-size: 14px;
  .content {
    background: #fff;
    margin-bottom: 10px;
    padding: 18px 30px;
  }
  .range-content {
    padding-bottom: 60px;
  }
  .caption {
    font-size: 16px;
  }

  .type-content {
    .item {
      color: #666;
      margin-right: 68px;
      .label {
        color: #222;
      }
    }
  }

  .tag-describe {
    margin-top: 20px;
  }

  .tag-remark {
    width: 580px;
    background: #f5f5f5;
    border-radius: 30px;
    margin-top: 20px;
    padding: 5px 15px;
    color: #999;
    min-height: 38px;
    .link {
      margin-left: 20px;
      color: #0081e5;
    }
    .hmicon {
      font-size: 14px;
    }
  }
}

.statistics {
  color: #222;
  margin-left: 8px;
  .count {
    font-size: 16px;
    color: #000;
    background: linear-gradient(90deg, #fedeec 0%, rgba(255, 255, 255, 0) 100%);
    border-left: 3px solid #e50065;
    border-radius: 2px;
    padding: 5px 15px;
    margin-right: 18px;
  }
}

.range-chart {
  position: relative;
  margin-top: 30px;
  margin-left: 80px;
  .scale {
    &::before {
      display: block;
      content: "";
      width: 1px;
      height: 98%;
      background: #eee;
      margin: 0 auto 10px;
    }
  }
  .x-axias {
    text-align: center;
  }

  .tag-type-list {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    .tag-type-item {
      position: relative;
      height: 18px;
      background: #fefefe;
      margin-bottom: 40px;
      white-space: nowrap;
      .attr {
        position: absolute;
        left: -80px;
        top: 50%;
        transform: translateY(-50%);
      }

      .count {
        position: absolute;
        top: 0;
        right: -98px;
        &.in-top {
          top: -20px;
          right: 0;
        }
      }
    }
  }
}
// .table {
//   width: 100%;
//   border-collapse: collapse;
//   thead {
//     background: #f7f7f7;
//   }
//   th,
//   td {
//     padding: 13px 0;
//     text-align: center;
//   }
//   tbody {
//     tr:nth-child(2n) {
//       background: #f7f7f7;
//     }
//   }
// }
.percentage {
  color: #999;
}
</style>
